/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Grid } from "@mui/material";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useEffect, useRef, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import Config from "../../Utils/Config";
import { DeviceModel } from "../../Utils/Models";
import { Vocabulary } from "../../Utils/Vocabulary";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import { onChangeDatePicker, onChangeTextField } from "../../Utils/Utils";
import moment from "moment";

type DeviceProps = {
  editDevice: DeviceModel | null;
  open: boolean;
  addOrUpdateDevice: (device: DeviceModel) => void;
  onClose: () => void;
};
export default function Device(props: DeviceProps) {
  const { editDevice, open, addOrUpdateDevice, onClose } = props;
  const [device, setDevice] = useState<DeviceModel>(new DeviceModel());
  const [pressOnSubmit, setPressOnSubmit] = useState(false);
  const ref: any = useRef();
  const buttons = (
    <Button
      onClick={resetDevice}
      variant="contained"
      style={{ marginBottom: 10, marginTop: 10, color: "white" }}
      fullWidth
      color="secondary"
    >
      {Vocabulary.reset}
    </Button>
  );
  /**
   *
   */
  useEffect(() => {
    if (editDevice) {
      setDevice(editDevice);
    } else {
      setDevice(new DeviceModel());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editDevice]);

  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }
  /**
   *
   */
  function resetDevice() {
    if (editDevice) {
      setDevice(editDevice);
    } else {
      setDevice(new DeviceModel());
    }
  }

  return (
    <ValidatorForm ref={ref} onSubmit={() => addOrUpdateDevice(device)}>
      <AddOrUpdateModel
        open={open}
        title={Vocabulary.device}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
        buttons={buttons ? buttons : null}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              variant="outlined"
              name="serialNumber"
              id="serialNumber"
              label={Vocabulary.serialNumber}
              fullWidth
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              value={device.serialNumber}
              onChange={(event) => setDevice(onChangeTextField(event, device))}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              variant="outlined"
              name="imeiNumber1"
              id="imeiNumber1"
              label={Vocabulary.imeiNumber1}
              fullWidth
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              value={device.imeiNumber1}
              onChange={(event) => setDevice(onChangeTextField(event, device))}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              variant="outlined"
              name="imeiNumber2"
              id="imeiNumber2"
              label={Vocabulary.imeiNumber2}
              fullWidth
              value={device.imeiNumber2}
              onChange={(event) => setDevice(onChangeTextField(event, device))}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              variant="outlined"
              name="name"
              id="name"
              label={Vocabulary.name}
              fullWidth
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              value={device.name}
              onChange={(event) => setDevice(onChangeTextField(event, device))}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              variant="outlined"
              name="configuration"
              id="configuration"
              label={Vocabulary.configuration}
              fullWidth
              value={device.configuration}
              onChange={(event) => setDevice(onChangeTextField(event, device))}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              variant="outlined"
              name="code"
              id="code"
              label={Vocabulary.code}
              fullWidth
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              value={device.code}
              onChange={(event) => setDevice(onChangeTextField(event, device))}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              variant="outlined"
              name="brand"
              id="brand"
              label={Vocabulary.brand}
              fullWidth
              value={device.brand}
              onChange={(event) => setDevice(onChangeTextField(event, device))}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              variant="outlined"
              name="model"
              id="model"
              label={Vocabulary.model}
              fullWidth
              value={device.model}
              onChange={(event) => setDevice(onChangeTextField(event, device))}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                name="purchaseDate"
                label={Vocabulary.purchaseDate}
                slotProps={{
                  textField: { style: { width: "100%" }, size: "small" },
                }}
                value={
                  typeof device.purchaseDate === "string"
                    ? moment(device.purchaseDate)
                    : device.purchaseDate
                }
                onChange={(e: any) =>
                  setDevice(onChangeDatePicker(e, device, "purchaseDate"))
                }
                format={Config.momentEUDateFormat}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
